module.exports = __webpack_public_path__ + "img/easy.84e46484.png";